(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom--history-timeline"] && !Shopify.designMode) return;
  try {
    
  class HistoryTimeline extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-history-track]');
      this.progress = this.querySelector('[data-history-progress]');
      this.cards = [...this.querySelectorAll('.custom-history__card')];
      if (!this.track) return;
      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const ratio = max > 0 ? this.track.scrollLeft / max : 1;
      if (this.progress) this.progress.style.transform = `scaleX(${Math.min(1, Math.max(0, ratio))})`;
      const left = this.track.scrollLeft + 1;
      this.cards.forEach((c) => c.classList.toggle('is-passed', c.offsetLeft + c.offsetWidth * 0.5 < left));
    }

  }
  if (!customElements.get('history-timeline')) customElements.define('history-timeline', HistoryTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom--sourcing-callout"] && !Shopify.designMode) return;
  try {
    
  class SourcingCallout extends HTMLElement {
    connectedCallback() {
      const v = this.querySelector('[data-sc-video]');
      if (!v || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          this.inView = e.isIntersecting;
          if (e.isIntersecting) {
            if (!v.dataset.loaded) { // fetch the file only when it is about to be seen
              v.dataset.loaded = '1';
              v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; });
              v.addEventListener('canplay', () => v.play().catch(() => {}), { once: true });
              v.addEventListener('pause', () => { if (this.inView && !v.ended) setTimeout(() => { if (this.inView) v.play().catch(() => {}); }, 250); });
              v.load();
            } else {
              v.play().catch(() => {});
            }
          } else v.pause();
        });
      }, { threshold: 0.25 });
      this.io.observe(v);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }
  if (!customElements.get('sourcing-callout')) customElements.define('sourcing-callout', SourcingCallout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom--team-pins"] && !Shopify.designMode) return;
  try {
    
  class TeamPins extends HTMLElement {
    connectedCallback() {
      this.pins = [...this.querySelectorAll('[data-team-pin]')];
      // Pin positions are % of the ORIGINAL photo. The photo is object-fit: cover, so re-project them onto the
      // cropped box whenever the box or image size changes; the CSS % values remain the no-JS fallback.
      this.photo = this.querySelector('.custom-team__photo');
      this.img = this.photo && this.photo.querySelector('img');
      this.place = () => {
        if (!this.img || !this.img.naturalWidth) return;
        const bw = this.photo.clientWidth, bh = this.photo.clientHeight;
        const scale = Math.max(bw / this.img.naturalWidth, bh / this.img.naturalHeight);
        const dw = this.img.naturalWidth * scale, dh = this.img.naturalHeight * scale;
        const ox = (bw - dw) / 2, oy = (bh - dh) / 2;
        this.pins.forEach((pin) => {
          const x = parseFloat(pin.style.getPropertyValue('--x')) / 100;
          const y = parseFloat(pin.style.getPropertyValue('--y')) / 100;
          pin.style.left = `${ox + x * dw}px`;
          pin.style.top = `${oy + y * dh}px`;
        });
      };
      if (this.img) {
        if (this.img.complete) this.place();
        this.img.addEventListener('load', this.place);
        this.ro = new ResizeObserver(this.place);
        this.ro.observe(this.photo);
      }
      this.pins.forEach((pin) => {
        pin.addEventListener('click', () => {
          const open = pin.getAttribute('aria-expanded') === 'true';
          this.pins.forEach((p) => p.setAttribute('aria-expanded', 'false'));
          pin.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
      this.onDoc = (e) => {
        if (!this.contains(e.target)) this.pins.forEach((p) => p.setAttribute('aria-expanded', 'false'));
      };
      document.addEventListener('click', this.onDoc);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onDoc);
    }
  }
  if (!customElements.get('team-pins')) customElements.define('team-pins', TeamPins);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
